export default {
  myApplications: [],
  applicationPropertyTypes: [],
  applicationAdvancedTypes: [],
  modalShow: false,
  modalMethod: '',
  modalPage: 0,
  pageIndex: 0,
  isPropertyModalVisible: false,
  isPersonModalVisible: false,
  isFormDirty: false,
  initalCreateApplication: {
    formData: {
      personId: -1,
      personContactId: -1,
      eigentuemer: {},
      kontaktPerson: {},
      objekt: {},
      gesuch: {}
    }
  },
  createApplication: {
    propertyId: null,
    propertyCommunityId: null,
    advancedCommunityId: null,
    finalCommunityId: null,
    applicationPropertyType: null,
    applicationAdvancedType: null,
    finalApplicationType: null,
    applictionTypeName: '',
    correspondence: null,
    formData: {
      personId: -1,
      personContactId: -1,
      eigentuemer: {},
      kontaktPerson: {},
      objekt: {},
      gesuch: {}
    }
  },
  updateApplication: {
    json: {}
  }
}
